import React from 'react';
import classnames from 'classnames';
import { twMerge } from 'tailwind-merge';

const Title = ({ title, subtitle, className }) => {
	const cls = twMerge(
		'font-bold text-neutral-800 dark:text-white transition-colors overflow-hidden',
		className
	);

	return (
		<div className={cls}>
			{title}
			<small className="block text-sm font-normal text-neutral-700 dark:text-neutral-400 leading-tight whitespace-nowrap text-ellipsis overflow-hidden transition-colors">
				{subtitle}
			</small>
		</div>
	);
};

export default Title;